
import './Teenused.css';
import {useState, useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Button, Navbar, Container, Nav, NavDropdown, Card, Row, Col, Image, Table, ThemeProvider } from 'react-bootstrap';

export default function Hero() {

    return (
      <div className='main'>
        <Container>
          <Container style={{marginBottom:"2.5rem", width:"75%"}}>
           <h1 style={{color:"#43ACE7"}}>
            <strong >Lisainfo</strong>
          </h1>
          <div style={{display:"flex", flexDirection:"column"}}>
            <a href='/failid/esmane-visiidi-abc-vanematele.docx' style={{textAlign:"start"}}>Esmane visiidi ABC vanematele.docx</a>
            <a href='/failid/kodulehe-hammaste-valgendamine.docx' style={{textAlign:"start"}}>Kodulehe hammaste valgendamine.docx</a>
          </div>

          </Container>
        </Container>


        </div>
    );
}